import axios from 'axios'

const AUTH = process.env.VUE_APP_AUTH

class AuthCalls {

  getSessionUser() {
    return axios.get(AUTH + 'user/', { withCredentials: true })
    .then(res => res.data);
  }

  updateUserSession(id, user) {
    return axios.put(AUTH + `user/${id}`, { user }, { withCredentials: true })
    .then(res => res.data);
  }

  logout() {
    return axios.get(AUTH + 'logout/', { withCredentials: true });
  }


}

const authCalls = new AuthCalls();
export default authCalls;
